import Vue from 'vue';
import './plugins/vuetify'
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import firebase from 'firebase';

Vue.config.productionTip = false;


  // Initialize Firebase
  var config = {
    apiKey: "AIzaSyDlMgbyLsXWS-AOgLEU_M0oP4UvgyJBU2g",
    authDomain: "cinema-workshop.firebaseapp.com",
    databaseURL: "https://cinema-workshop.firebaseio.com",
    projectId: "cinema-workshop",
    storageBucket: "cinema-workshop.appspot.com",
    messagingSenderId: "556979310152"
  };
  firebase.initializeApp(config);
  
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
